import RecorderHome from './RecorderHome';

export default RecorderHome;
